var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"calendar",attrs:{"title":"Calendar"}},[_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Aktive',
			value: 'active'
		},
		{
			label: 'Alle',
			value: 'all'
		},
	]},slot:"tools",model:{value:(_vm.workers),callback:function ($$v) {_vm.workers=$$v},expression:"workers"}}),_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Postnr',
			value: 'zip'
		},
		{
			label: 'Ankomst',
			value: 'arrival'
		},
		{
			label: 'Omfang',
			value: 'volume'
		},
		{
			label: 'Resume',
			value: 'summary'
		}
	]},slot:"tools",model:{value:(_vm.info),callback:function ($$v) {_vm.info=$$v},expression:"info"}}),_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Detaljeret',
			value: 'detailed'
		},
		{
			label: 'Komprimeret',
			value: 'condensed'
		}
	]},slot:"tools",model:{value:(_vm.condensed),callback:function ($$v) {_vm.condensed=$$v},expression:"condensed"}}),_c('button-view',{attrs:{"slot":"tools","label":"..."},on:{"click":_vm.select},slot:"tools"}),_c('button-view',{staticStyle:{"display":"none"},attrs:{"slot":"tools","label":_vm.date},on:{"click":function($event){$event.stopPropagation();return _vm.debug($event)}},slot:"tools"}),_c('div',{staticClass:"layout"},[_c('div',{staticClass:"search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"type":"text","placeholder":"Søg efter..."},domProps:{"value":(_vm.search)},on:{"keyup":_vm.searchKeyUp,"input":function($event){if($event.target.composing)return;_vm.search=$event.target.value}}})]),_c('date-picker-std-view',{staticClass:"date",style:({
			opacity: this.search == '' ? 1 : 0,
			transition: 'opacity 250ms'
		}),attrs:{"status":_vm._status},on:{"browse":_vm.updateStatus},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_c('div',{class:['status', _vm.dateStatus]},[_c('div',{class:{
				left: true,
				active: _vm.dateStatus == 'open'
			},on:{"click":function($event){return _vm.setDateStatus('open')}}},[_vm._v("Åben")]),_c('div',{class:{
				active: _vm.dateStatus == 'restricted'
			},on:{"click":function($event){return _vm.setDateStatus('restricted')}}},[_vm._v("Spørg")]),_c('div',{class:{
				right: true,
				active: _vm.dateStatus == 'closed'
			},on:{"click":function($event){return _vm.setDateStatus('closed')}}},[_vm._v("Lukket")])]),_c('div',{staticClass:"booking"},[_c('div',{staticClass:"label"},[_vm._v("Tilgængeligt mandskab")]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._available))])]),_c('div',{staticClass:"meeting"},[_c('div',{staticClass:"label"},[_vm._v("Fremmøde")]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm._meeting.met)+" / "+_vm._s(_vm._meeting.booked))])]),_c('div',{staticClass:"tabs",style:({
			opacity: this.search == '' ? 1 : 0,
			transition: 'opacity 250ms'
		})},[_c('plethora-tabs-view',{attrs:{"tabs":[
				{
					label: 'Opgaver',
					value: 'tasks',
					badge: {
						visible: false
					}
				},
				{
					label: _vm.$store.getters.leadRole.plural,
					value: 'employees'
				},
				{
					label: 'Udeblevet',
					value: 'absent'
				}
				/*{
					label: null,
					value: 'red',
					badge: {
						visible: true,
						label: 30,
						style: {
							background: {
								color: '#f7223f'
							},
							font: {
								color: 'white'
							}
						}
					}
				},
				{
					label: null,
					value: 'yellow',
					badge: {
						visible: true,
						label: 10,
						style: {
							background: {
								color: '#FFCF00'
							},
							font: {
								color: 'white'
							}
						}
					}
				},
				{
					label: null,
					value: 'green',
					badge: {
						visible: true,
						label: 7,
						style: {
							background: {
								color: '#00c017'
							},
							font: {
								color: 'white'
							}
						}
					}:/
				/*{
					label: 'Dagens',
					value: 'scheduled',
					badge: {
						visible: true,
						label: 30,
						style: {
							background: {
								color: '#FFCF00'
							},
							font: {
								color: 'white'
							}
						}
					}
				}/*,
				{
					label: 'Advarsler',
					value: 'warnings',
					bagde: {
						visible: true,
						label: 4,
						style: {
							background: {
								color: '#FFCF00'
							},
							font: {
								color: 'white'
							}
						}
					}
				}*/
			]},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}})],1),_c('perfect-scrollbar',{staticClass:"tasks",style:({
			gridRow: _vm.search == '' ? '7' : '2 / 8',
			transition: 'grid-row 250ms'
		}),attrs:{"name":"task","tag":"div"}},[_c('transition-group',{attrs:{"name":"task","tag":"div"}},[_vm._l((_vm._tasks),function(task){return _c('div',{key:task.id,class:['task', 'move'],on:{"contextmenu":function($event){$event.preventDefault();return _vm.taskContext($event, task)},"mouseenter":function($event){return _vm.$store.commit('hover', [task, 'right', 'task'])},"mouseleave":function($event){return _vm.$store.commit('hover', [null, 'right', 'task'])}}},[_c('div',{staticClass:"color",style:({ backgroundColor: _vm._types.hasOwnProperty(task.type) ? _vm._types[task.type].color : 'yellow' })}),_c('div',{staticClass:"name"},[_vm._v("#"+_vm._s(task.num)+" "+_vm._s(task.name == '' ? '-' : task.name)),_c('br'),_vm._l((task.status.instr),function(a,b){return _c('span',{key:b},[_vm._v(_vm._s(a))])})],2),_c('div',{staticClass:"zip",domProps:{"innerHTML":_vm._s(_vm.getInfo(task))}}),_c('div',{staticClass:"arrow",staticStyle:{"display":"none"}},[_vm._v("X")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.view == 'planning'),expression:"view == 'planning'"}],staticClass:"teams"},_vm._l((task.teams),function(team,a){return _c('div',{key:a,staticClass:"team"},[_c('div',{staticClass:"header",style:({ backgroundColor: _vm.colors[team.status] }),attrs:{"draggable":"true"},on:{"dragstart":function($event){return _vm.dragStart(task, team)},"dragend":function($event){return _vm.dragEnd()},"click":function($event){$event.stopPropagation();return _vm.bookResource($event, task, team)}}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(team.name))]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(team.desc != ''),expression:"team.desc != ''"}],staticClass:"desc"},[_vm._v(_vm._s(team.desc))])]),_vm._l((team.reqs),function(req,b){return _c('div',{key:b,staticClass:"reqs"},[_c('div',{staticClass:"row header"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._roles.hasOwnProperty(req.role) ? _vm._roles[req.role].label : req.role))]),_c('div',{staticClass:"state"},[_vm._v(_vm._s(req.booked)+" / "+_vm._s(req.qty))])]),_vm._l((req.props),function(prop,c){return _c('div',{key:c,staticClass:"row"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._props.hasOwnProperty(c) ? _vm._props[c].label : c))]),_c('div',{staticClass:"state"},[_vm._v(_vm._s(prop.booked)+" / "+_vm._s(prop.qty))])])})],2)})],2)}),0)])}),_vm._l((_vm._emps),function(e){return _c('div',{key:'emp' + e.id,staticClass:"employee",attrs:{"draggable":"true"},on:{"dragstart":function($event){return _vm.empDragStart(e)},"dragend":function($event){return _vm.empDragEnd()}}},[_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(e.name)),_c('br'),(!e.reserve)?_c('div',{staticClass:"status",style:({ backgroundColor: '#4cb050' })},[_vm._v("Arbejdsdag 3")]):_vm._e(),(e.reserve)?_c('div',{staticClass:"status",style:({ backgroundColor: e.reserve.color })},[_vm._v(_vm._s(e.reserve.note))]):_vm._e(),(e.rating != '')?_c('div',{staticClass:"rating"},[_vm._v(_vm._s(e.rating))]):_vm._e()]),(e.bookings.length > 0)?_c('div',{staticClass:"bookings"},_vm._l((e.bookings),function(b){return _c('div',{key:'booking' + b.id,staticClass:"task",on:{"click":function($event){return _vm.unbook({ res_type: 'employee', id: b.id })}}},[_vm._v("#"+_vm._s(b.task_num)+" "+_vm._s(b.task_name)),_c('svg-icon',{staticClass:"close",attrs:{"icon":"close"},on:{"click":function($event){return _vm.unbook({ res_type: 'employee', id: b.id })}}})],1)}),0):_vm._e(),(e.bookings.length > 0)?_c('div',{staticClass:"vehicles"},_vm._l((e.vehicles),function(v){return _c('div',{key:'vehicles' + v.id,staticClass:"vehicle"},[_vm._v(_vm._s(v.name))])}),0):_vm._e(),_c('div',{staticClass:"props"},_vm._l((_vm.props2(e)),function(p,j){return _c('div',{key:j},[_vm._v(_vm._s(p))])}),0)])}),_vm._l((_vm._absent),function(e){return _c('div',{key:'abs' + e.id,staticClass:"employee",staticStyle:{"cursor":"default"}},[_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(e.name)),_c('br'),(false)?_c('div',{staticClass:"status",style:({ backgroundColor: '#f7223f' })},[_vm._v("00:00")]):_vm._e()])])}),(_vm._tasks == null)?_c('spinner-view'):_vm._e()],2)],1),_c('resource-view',{staticClass:"resources",attrs:{"info":_vm.info,"filters":_vm._filters,"filter":_vm.filter,"bookings":_vm.bookings,"hoverRes":_vm.hoverRes,"types":_vm._types,"tasks":_vm._allTasks,"resources":_vm._resources_norm,"date":_vm.date,"drag":_vm.drag,"reservations":_vm.reservations,"internal":_vm.ownership == 'internal',"external":_vm.ownership == 'external',"condensed":_vm.condensed == 'condensed',"planned":_vm.capacity == 'all' || _vm.capacity == 'planned',"free":_vm.capacity == 'all' || _vm.capacity == 'free'},on:{"updateBooking":_vm.updateBooking,"resource_context":_vm.resource_context,"track_context":_vm.track_context,"move":_vm.move,"pin":_vm.pin,"context":_vm.bookingContext,"filter":_vm.setFilter,"unbook":_vm.unbook,"copyBookings":_vm.copyBookings,"book":_vm.book,"onDragStart":_vm.dragStart,"onDragEnd":_vm.dragEnd,"hover":_vm.hover}})],1),(_vm.$store.state.hoverType == 'vehicle')?_c('vehicle-hover-view',{attrs:{"item":_vm.$store.state.hover,"align":_vm.$store.state.hoverAlign,"roles":_vm.vehicleRoles,"events":_vm.events}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }